import { useState } from 'react';
import { useGetPaymentService } from '../../store';
import { useGetDefaultDepositAmount } from '../useGetDefaultDepositAmount';

export const useLastDepositAmount = () => {
  // @ts-expect-error should be solved inside useGetPaymentService
  const { lastDepositAmount: defaultServiceValue = '' } =
    useGetPaymentService();
  const [lastDepositAmount, setLastDepositAmount] =
    useState(defaultServiceValue);

  const defaultDepositAmount = useGetDefaultDepositAmount(lastDepositAmount);

  return {
    lastDepositAmount: defaultDepositAmount,
    updateLastDepAmount: setLastDepositAmount
  };
};
